import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemibold: 600,
  },
  palette: {
    primary: {
      main: '#1976d2', // Blue
    },
    secondary: {
      main: '#dc004e', // Red
    },
    error: {
      main: '#f44336', // Red
    },
    warning: {
      main: '#ff9800', // Orange
    },
    lightBlack: {
      main: '#292929', // Blue
    },
    green: {
      main: '#24A147', // Green
    },
    lightGray: {
      main: "#7C7C7C"
    },
    darkBlue: {
      main: "#192A3E"
    },
    darkBrown: {
      main: "#442703"
    },
    white: {
      main: "#FFFFFF"
    }
  },
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 4,
          borderRadius: 5,
        },
        colorPrimary: {
          backgroundColor: '#E7E7E7',
        },
        bar: {
          borderRadius: 5,
          backgroundColor: '#24A147',
        },
      },
    },
  },
  customStyles: {
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      height: '100svh',
      position: 'relative',
      backgroundColor: "#FAFAFA",
    },
    valetCurrentActivityContainer: {
      padding: "16px 16px 0px 16px"
    },
    valetRecallContainer: {
      position: 'absolute',
      bottom: 0,
      zIndex: 9999,
      boxShadow: 3,
      backgroundColor: "#FFFFFF",
      padding: "16px",
      width: "100%",
      borderRadius: "8px 8px 0px 0px"
    },
    recallActionContainer: {
      display:"flex",
      justifyContent:" space-between",
      alignItems:"center",
      position: 'absolute',
      bottom: 0,
      zIndex: 9999,
      backgroundColor: "#FFFFFF",
      width: "100%",
      right: 0,
      padding:"16px",
      borderRadius: "8px 8px 0px 0px"
    },
    bottomSheetOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0)",
      zIndex: 8
    },
    bottomSheetContent: {
      overflow: "auto",
      height: "calc(100% - 40px)",
      paddingBottom: "400px"
    },
    dragHandle: {
      width: "64px",
      height: "4px",
      background: "#DCDCDC",
      borderRadius: "2.5px",
      margin: "10px auto",
      cursor: "grab",
      touchAction: "none"
    },
    valetActivitiesContainer: {
      marginTop: "1px"
    },
    circle: {
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      overflow: "hidden"
    },
    verticalLine: {
      width: "2px",
      height: "20px",
      backgroundColor: "#DCDCDC"
    },
    valetBookingDetailsContainer: {
      marginTop: "24px"
    },
    defaultParkingImgContainer: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      marginTop: "16px",
      overflow: "hidden",
      borderRadius: "10px",
      width:"100%",
      maxWidth:"450px",
      height: "152px"
    },
    defaultParkingImgBlur: {
      width: "100%",
      height: "auto"
    },
    defaultParkingImgOverlay: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
      paddingLeft: "34px",
      paddingRight: "34px",
      borderRadius: "10px",
      width: "100%",
      fontSize: "14px",
      color: "#FFFFFF",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    gradientButton: {
      display: "flex",
      padding: "10px 16px",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      width:"100%",
      textTransform: "capitalize",
      borderRadius: "4px",
      background: "linear-gradient(270deg, #18CC69 45%, #8BE5B4 100%)"
    },
    viewImageButton: {
      display: "flex",
      padding: "4px 6px 4px 6px",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      textTransform: "capitalize",
      borderRadius: "4px",
      background: "rgba(255, 255, 255, 0.70)",
      backdropFilter: "blur(8px)"
    },
    bottomSheetModel: {
      position: "fixed",
      bottom: "-100%",
      left: "0",
      right: "0",
      height: "70vh",
      background: "white",
      boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
      transition: "bottom 0.3s ease-in-out",
      zIndex: "10000",
      borderRadius: "16px 16px 0px 0px"
    },
    bottomSheetModelVisible: {
      bottom: "0",
    },
    bottomSheetModelOverlay: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      background: "rgba(0, 0, 0, 0.5)",
      zIndex: "999",
    },
    
    bottomSheetModelContent: {
      padding: "20px",
      height: "100%", // Ensure content takes up full height
    overflowY: "auto",
    },
    closeModalBtn: {
      background: "none",
      border: "none",
      fontSize: "16px",
      cursor: "pointer",
      position: "absolute",
      top: "10px",
      right: "10px",
    },
    ratingContent: {
      textAlign:"center",
      fontSize: "50px"
    }
  },

});

export default theme;